<template>
  <div>
    <h4 class="mb-4"><strong>El número no posee plan</strong></h4>
    <p>Ingresa a tu sucursal virtual para seleccionar un plan.</p>

    <a href="https://mivirgin.virginmobile.cl/" class="btn btn-primary" type="button">
      Ir a sucursal virtual
    </a>

  </div>
</template>

<script>
export default {
  name: 'PaymentTariffUnknown',

  setup() {
    return {
      error: {
        msisdn: false
      },
      msisdn: '',
    }
  },
}
</script>

<style scoped>
</style>
